import * as swcHelpers from '@swc/helpers';

const formStatesToValues = (formState)=>{
    return Object.entries(formState).reduce((item, [key, value])=>{
        return swcHelpers.objectSpread({}, item, {
            [key]: value === null || value === void 0 ? void 0 : value.value
        });
    }, {});
};

export { formStatesToValues };
//# sourceMappingURL=form-state-to-values.js.map
